module.exports = __webpack_public_path__ + "static/img/page2.21f19744.jpg";